const FULL_DASH_ARRAY = 283;
const WARNING_THRESHOLD = 10;
const ALERT_THRESHOLD = 5;

const COLOR_CODES = {
  info: {
    color: "green"
  },
  warning: {
    color: "orange",
    threshold: WARNING_THRESHOLD
  },
  alert: {
    color: "red",
    threshold: ALERT_THRESHOLD
  }
};

export default {
  name: "base-timer",
  data() {
    return {
      timerInterval: null
    };
  },

  computed: {
    circleDasharray() {
      return `${(this.timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
    },

    formattedTimeLeft() {
      const timeLeft = this.timeLeft;
      const hours = Math.floor(timeLeft / 3600);
      let minutes = Math.floor((timeLeft - hours*3600) / 60);
      let seconds = timeLeft % 60;

      if (minutes < 10) {
        minutes = `0${minutes}`;
      }

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      return `${hours}:${minutes}:${seconds}`;
    },

    timeLeft() {
      return this.$timer.timeLimit - this.$timer.timePassed;
    },

    timeFraction() {
      const rawTimeFraction = this.timeLeft / this.$timer.timeLimit;
      return rawTimeFraction - (1 / this.$timer.timeLimit) * (1 - rawTimeFraction);
    },

    remainingPathColor() {
      const { alert, warning, info } = COLOR_CODES;

      if (this.timeLeft <= alert.threshold) {
        return alert.color;
      } else if (this.timeLeft <= warning.threshold) {
        return warning.color;
      } else {
        return info.color;
      }
    }
  },

  watch: {
    timeLeft(newValue) {
      if (newValue === 0) {
        this.$eventHub.$emit("error-happened", {
          title: "warning",
          id: "",
          warningMessage: this.$t("idleTooLongWarning")
        });
        this.emitSignalForLogout();
      }
    }
  },
  mounted() {
    this.startTimer();
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  },
  methods: {
    emitSignalForLogout() {
      clearInterval(this.timerInterval);
      this.$emit("time-up");
    },

    startTimer() {
      this.$clearCountdown();
      this.timerInterval = setInterval(this.$startCountdown, 1000);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixin/BaseTimer.js